import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import v7 from "../images/v7.mp4";
import v8 from "../images/v8.mp4";
import v9 from "../images/v9.mp4";
import v10 from "../images/v10.mp4";

import Tanya from "../images/Tanya.jpeg";
import Ritu from "../images/Ritu.jpeg";
import work1 from "../images/work1.jpeg";
import work2 from "../images/work2.jpeg";
import work3 from "../images/work3.jpeg";
import work4 from "../images/work4.jpeg";
import work5 from "../images/work5.jpeg";



// ============================================================
// DRIFT WALL DATA
// ============================================================

const ITEMS = [
  {
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=900",
    title: "MAKEUP",
  },
  {
    image:
      "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=900",
    title: "BEAUTY",
  },
  {
    image:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=900",
    title: "COSMETICS",
  },
  {
    image:
      "https://images.unsplash.com/photo-1583241800698-e8ab01830a07?w=900",
    title: "MAKEUP",
  },
  {
    image:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=900",
    title: "BEAUTY",
  },
  {
    image:
      "https://images.unsplash.com/photo-1526045478516-99145907023c?w=900",
    title: "LIPSTICK",
  },
  {
    image:
      "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=900",
    title: "SKINCARE",
  },
  {
    image:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=900",
    title: "MAKEUP ARTIST",
  },
  {
    image:
      "https://images.unsplash.com/photo-1567721913486-6585f069b332?w=900",
    title: "COSMETICS",
  },
  {
    image:
      "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=900",
    title: "BEAUTY",
  },
  {
    image:
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=900",
    title: "MAKEUP",
  },
  {
    image:
      "https://images.unsplash.com/photo-1525507119028-ed4c629a60a3?w=900",
    title: "BEAUTY",
  },
  {
    image:
      "https://images.unsplash.com/photo-1485230895905-ec40ba36b9bc?w=900",
    title: "COSMETICS",
  },
  {
    image:
      "https://images.unsplash.com/photo-1596704017254-9b121068fb31?w=900",
    title: "SKINCARE",
  },
  {
    image:
      "https://images.unsplash.com/photo-1612817288484-6f916006741a?w=900",
    title: "BEAUTY",
  },
];


// ============================================================
// WORK GALLERY DATA
// ============================================================
const WORK_ITEMS = [
  {
    type: "image",
    src: work1,
    category: "MAKEUP TRANSFORMATION",
    title: "Before & After",
  },

  {
    type: "image",
    src: work2,
    category: "BRIDAL MAKEUP",
    title: "Bridal Elegance",
  },

  {
    type: "image",
    src: work3,
    category: "BRIDAL LOOK",
    title: "Traditional Glam",
  },

  {
    type: "image",
    src: work4,
    category: "BRIDAL MAKEUP",
    title: "Classic Beauty",
  },

  {
    type: "image",
    src: work5,
    category: "BRIDAL LOOK",
    title: "Signature Beauty",
  },
];

// ============================================================
// TEAM DATA
// ============================================================
const TEAM_ITEMS = [
  {
    image: Tanya,
    title: "TANYA AGGARWAL",
    subtitle: "FOUNDER & MAKEUP ARTIST",
    borderColor: "#ff3b30",
    spotlightColor: "rgba(255, 59, 48, 0.55)",
  },

  {
    image: Ritu,
    title: "RITU GUPTA",
    subtitle: "MAKEUP & BEAUTY CONSULTANT",
    borderColor: "#2979ff",
    spotlightColor: "rgba(41, 121, 255, 0.55)",
  },
];


// ============================================================
// RESPONSIVE COLUMN COUNT
// ============================================================

function getColumns() {
  if (typeof window === "undefined") {
    return 5;
  }

  if (window.innerWidth >= 1400) {
    return 5;
  }

  if (window.innerWidth >= 1050) {
    return 4;
  }

  if (window.innerWidth >= 700) {
    return 3;
  }

  return 2;
}


// ============================================================
// PORTFOLIO DATA
// ============================================================

const PORTFOLIO_ITEMS = [
  {
    text: "BRIDAL MAKEUP",
    image:
      "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=1200",
  },

  {
    text: "PARTY MAKEUP",
    image:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=1200",
  },

  {
    text: "ENGAGEMENT LOOK",
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=1200",
  },

  {
    text: "RECEPTION LOOK",
    image:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=1200",
  },

  {
    text: "HD MAKEUP",
    image:
      "https://images.unsplash.com/photo-1583241800698-e8ab01830a07?w=1200",
  },

  {
    text: "GLAM LOOKS",
    image:
      "https://images.unsplash.com/photo-1567721913486-6585f069b332?w=1200",
  },
];


// ============================================================
// DRIFT WALL
// ============================================================

function DriftWall() {
  const containerRef = useRef(null);
  const tracksRef = useRef([]);
  const offsetsRef = useRef([]);
  const speedsRef = useRef([]);
  const rafRef = useRef(null);
  const lastTimeRef = useRef(null);

  const [columns, setColumns] = useState(getColumns);
  const [height, setHeight] = useState(0);
  const [hovered, setHovered] = useState(null);

  const tileHeight = 150;
  const gap = 18;
  const speed = 45;


  // ==========================================================
  // RESPONSIVE COLUMNS
  // ==========================================================

  useEffect(() => {
    const handleResize = () => {
      setColumns(getColumns());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  // ==========================================================
  // CONTAINER HEIGHT
  // ==========================================================

  useLayoutEffect(() => {
    const element = containerRef.current;

    if (!element) {
      return;
    }

    const updateHeight = () => {
      setHeight(element.clientHeight);
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);


  // ==========================================================
  // GROUP ITEMS INTO COLUMNS
  // ==========================================================

  const grouped = useMemo(() => {
    const result = Array.from(
      { length: columns },
      () => []
    );

    ITEMS.forEach((item, index) => {
      result[index % columns].push(item);
    });

    return result;
  }, [columns]);


  const step = tileHeight + gap;


  // ==========================================================
  // ALTERNATE COLUMN DIRECTIONS
  // ==========================================================

  useEffect(() => {
    offsetsRef.current = grouped.map(
      (_, index) =>
        index % 2 === 0
          ? 0
          : -(step * 0.5)
    );

    speedsRef.current = grouped.map(
      (_, index) =>
        index % 2 === 0
          ? -speed
          : speed
    );

    lastTimeRef.current = null;
  }, [grouped, step]);


  // ==========================================================
  // ANIMATION
  // ==========================================================

  const animate = useCallback(
    (time) => {
      if (lastTimeRef.current === null) {
        lastTimeRef.current = time;
      }

      const delta = Math.min(
        (time - lastTimeRef.current) / 1000,
        0.05
      );

      lastTimeRef.current = time;

      tracksRef.current.forEach(
        (track, index) => {
          if (!track) {
            return;
          }

          const velocity =
            speedsRef.current[index] || 0;

          let offset =
            offsetsRef.current[index] || 0;

          offset += velocity * delta;

          const columnHeight =
            grouped[index].length * step;


          // MOVE UP

          if (
            velocity < 0 &&
            offset < -columnHeight
          ) {
            offset += columnHeight;
          }


          // MOVE DOWN

          if (
            velocity > 0 &&
            offset > 0
          ) {
            offset -= columnHeight;
          }

          offsetsRef.current[index] = offset;

          track.style.transform =
            `translate3d(0, ${offset}px, 0)`;
        }
      );

      rafRef.current =
        requestAnimationFrame(animate);
    },
    [grouped, step]
  );


  // ==========================================================
  // START / STOP ANIMATION
  // ==========================================================

  useEffect(() => {
    lastTimeRef.current = null;

    rafRef.current =
      requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [animate]);


  // ==========================================================
  // REPEAT CARDS
  // ==========================================================

  const copies = Math.max(
    8,
    Math.ceil((height + 500) / step)
  );


  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <section
      className="home"
      ref={containerRef}
    >

      <div
        className="drift-wall"
        style={{
          "--columns": columns,
          "--gap": `${gap}px`,
        }}
      >

        <div className="drift-wall__grid">

          {grouped.map(
            (column, columnIndex) => {

              const repeated = Array.from(
                {
                  length: copies,
                },
                () => column
              ).flat();

              return (
                <div
                  className="drift-wall__column"
                  key={columnIndex}
                >

                  <div
                    className="drift-wall__track"
                    ref={(element) => {
                      tracksRef.current[
                        columnIndex
                      ] = element;
                    }}
                  >

                    {repeated.map(
                      (item, index) => {

                        const key =
                          `${columnIndex}-${index}`;

                        return (
                          <div
                            className={`drift-wall__tile ${
                              hovered === key
                                ? "is-hovered"
                                : ""
                            }`}
                            key={key}
                            onMouseEnter={() =>
                              setHovered(key)
                            }
                            onMouseLeave={() =>
                              setHovered(null)
                            }
                          >

                            <div className="drift-wall__inner">

                              <img
                                src={item.image}
                                alt={item.title}
                                draggable="false"
                              />

                              <div className="drift-wall__overlay" />

                              <span className="drift-wall__title">
                                {item.title}
                              </span>

                            </div>

                          </div>
                        );
                      }
                    )}

                  </div>

                </div>
              );
            }
          )}

        </div>

      </div>

    </section>
  );
}


// ============================================================
// CHROMA GRID
// ============================================================

function ChromaGrid({
  items = [],
  columns = 3,
  radius = 320,
}) {
  const gridRef = useRef(null);


  useEffect(() => {
    const grid = gridRef.current;

    if (!grid) {
      return;
    }

    const cards =
      grid.querySelectorAll(
        ".home-chroma-card"
      );


    // ========================================================
    // MOUSE MOVE
    // ========================================================

    const handleMouseMove = (event) => {

      cards.forEach((card) => {

        const rect =
          card.getBoundingClientRect();

        const x =
          event.clientX - rect.left;

        const y =
          event.clientY - rect.top;


        const centerX =
          rect.left +
          rect.width / 2;

        const centerY =
          rect.top +
          rect.height / 2;


        const distance = Math.sqrt(
          Math.pow(
            event.clientX - centerX,
            2
          ) +
          Math.pow(
            event.clientY - centerY,
            2
          )
        );


        const intensity = Math.max(
          0,
          1 - distance / radius
        );


        card.style.setProperty(
          "--mouse-x",
          `${x}px`
        );

        card.style.setProperty(
          "--mouse-y",
          `${y}px`
        );

        card.style.setProperty(
          "--chroma-intensity",
          intensity
        );
      });
    };


    // ========================================================
    // MOUSE LEAVE
    // ========================================================

    const handleMouseLeave = () => {

      cards.forEach((card) => {

        card.style.setProperty(
          "--chroma-intensity",
          "0"
        );

      });

    };


    grid.addEventListener(
      "mousemove",
      handleMouseMove
    );

    grid.addEventListener(
      "mouseleave",
      handleMouseLeave
    );


    return () => {

      grid.removeEventListener(
        "mousemove",
        handleMouseMove
      );

      grid.removeEventListener(
        "mouseleave",
        handleMouseLeave
      );

    };

  }, [radius]);


  // ==========================================================
  // CHROMA GRID JSX
  // ==========================================================

  return (
    <div
      ref={gridRef}
      className="home-chroma-grid"
      style={{
        "--chroma-columns": columns,
      }}
    >

      {items.map((item, index) => (

        <div
          className="home-chroma-card"
          key={index}
          style={{
            "--card-border":
              item.borderColor,

            "--spotlight":
              item.spotlightColor,
          }}
        >

          <img
            src={item.image}
            alt={item.title}
            draggable="false"
          />


          <div className="home-chroma-overlay" />

          <div className="home-chroma-light" />

          <div className="home-chroma-content">

            <h3>
              {item.title}
            </h3>

            <p>
              {item.subtitle}
            </p>

          </div>

        </div>

      ))}

    </div>
  );
}


// ============================================================
// FLOWING MENU
// ============================================================

function FlowingMenu({ items = [] }) {
  return (
    <div className="flowing-menu">

      {items.map((item, index) => (

        <a
          href={item.href || "#"}
          className="flowing-menu-item"
          key={index}
        >

          <div className="flowing-menu-main">

            <span className="flowing-menu-title">
              {item.text}
            </span>

            <span className="flowing-menu-arrow">
              ↗
            </span>

          </div>


          <div className="flowing-menu-marquee">

            <div className="flowing-menu-track">

              {[...Array(6)].map((_, i) => (

                <div
                  className="flowing-menu-image"
                  key={i}
                >

                  <img
                    src={item.image}
                    alt={item.text}
                    draggable="false"
                  />

                  <span>
                    {item.text}
                  </span>

                </div>

              ))}

            </div>

          </div>

        </a>

      ))}

    </div>
  );
}


// ============================================================
// WORK GALLERY
// ============================================================

function WorkGallery() {
  return (
    <section className="home-work-section">

      {/* HEADING */}

      <div className="home-work-heading">

        <span>
          OUR WORK
        </span>

        <h2>
          Beauty that
          <br />
          <em>speaks for itself.</em>
        </h2>

        <p>
          A glimpse into our makeup artistry,
          bridal transformations and signature looks.
        </p>

      </div>


      {/* GALLERY */}

      <div className="home-work-grid">

        
{WORK_ITEMS.map((work, index) => (
  <div
    className={`work-card work-card-${index + 1}`}
    key={index}
  >
    <img
      src={work.src}
      alt={work.title}
      draggable="false"
    />

    <div className="work-card-shine"></div>

    <div className="work-card-overlay">
      <div className="work-card-content">
        <span>{work.category}</span>
        <h3>{work.title}</h3>
      </div>

      <div className="work-card-arrow">
        ↗
      </div>
    </div>
  </div>
))}
      </div>

    </section>
  );
}


// ============================================================
// HOME PAGE
// ============================================================

function Home() {

  return (
    <div className="home-page">


      {/* ======================================================
          DRIFT WALL
      ====================================================== */}

      <DriftWall />


      {/* ======================================================
          OUR TEAM
      ====================================================== */}

      <section className="home-team-section">


        {/* TEAM HEADING */}

        <div className="home-team-heading">

          <span className="home-team-eyebrow">
            MEET OUR TEAM
          </span>


          <h2>
            The artists behind
            <br />
            <em>your beauty.</em>
          </h2>


          <p>
            Meet the talented professionals
            behind Makeup by Tanya,
            dedicated to creating beautiful
            and unforgettable looks.
          </p>

        </div>


        {/* CHROMA GRID */}

        <ChromaGrid
          columns={3}
          radius={320}
          items={TEAM_ITEMS}
        />

      </section>


      {/* ======================================================
          OUR PORTFOLIO
      ====================================================== */}

      <section className="home-portfolio-section">

        <div className="home-portfolio-heading">

          <span className="home-team-eyebrow">
            OUR PORTFOLIO
          </span>


          <h2>
            Our signature
            <br />
            <em>beauty looks.</em>
          </h2>


          <p>
            Explore our makeup artistry and signature looks
            created for every special occasion.
          </p>

        </div>


        <FlowingMenu
          items={PORTFOLIO_ITEMS}
        />

      </section>


      {/* ======================================================
          OUR WORK GALLERY
      ====================================================== */}

      <WorkGallery />





      {/* ======================================================
    BRIDAL REELS
====================================================== */}

<section className="home-reels-section">

  <div className="home-reels-heading">
    <span>BRIDAL REELS</span>

    <h2>
      Beauty in
      <br />
      <em>motion.</em>
    </h2>

    <p>
      Watch our latest bridal transformations,
      makeup looks and beauty moments.
    </p>
  </div>


  <div className="home-reels-grid">

   <div className="reel-card">
  <video
    src={v7}
    autoPlay
    muted
    controls
    playsInline
    loop
    preload="metadata"
  />
</div>

<div className="reel-card">
  <video
    src={v8}
    autoPlay
    muted
    controls
    playsInline
    loop
    preload="metadata"
  />
</div>

<div className="reel-card">
  <video
    src={v9}
    autoPlay
    muted
    controls
    playsInline
    loop
    preload="metadata"
  />
</div>

<div className="reel-card">
  <video
    src={v10}
    autoPlay
    muted
    controls
    playsInline
    loop
    preload="metadata"
  />
</div>

  </div>

</section>


    </div>
  );
}


export default Home;